import { MediaMatcher } from '@angular/cdk/layout';
import { ChangeDetectorRef, Component } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { MapHelperService } from 'src/services/map-helper.service';
import { filter, Subscription } from 'rxjs';
import { MAP_BUILD_NAMES, MAP_MODULE_NAMES } from 'src/models/common/EnumMapas';
import { LayerService } from '../../../../services/Layers.service';
import { LocationsService } from '../../../../services/Locations.service';
import { PanelMapLayerService } from '../../../../services/Panel-Map-Layer.service';

@Component({
  selector: 'panel-map-layers',
  templateUrl: './panel-map-layers.component.html',
  styleUrls: ['./panel-map-layers.component.css'],
  animations: [
      trigger("mostrarLista", [
        state("visible", style({ opacity: 1, height: "*" })),
        state("hidden", style({ opacity: 0, height: "0px", overflow: "hidden", display: "none" })),
        transition("visible <=> hidden", animate("300ms ease-in-out")),
      ]),
    ]
})
export class PanelMapLayersComponent {
  listaCapasVisible: boolean = false;

  Subscription_GetMapMainSource: Subscription;
  
    mobileQuery: MediaQueryList;
    private _mobileQueryListener: () => void;

    constructor(
      public locationService: LocationsService,
      public panelMapLayerService: PanelMapLayerService,
      public layerCatalogService: LayerService,
      private media: MediaMatcher,
      changeDetectorRef: ChangeDetectorRef,
      private mapHelper: MapHelperService,
    ) {
      this.mobileQuery = media.matchMedia("(min-width: 769px)");
      this._mobileQueryListener = () => changeDetectorRef.detectChanges();
      this.mobileQuery.addListener(this._mobileQueryListener);

    }
  
    ngOnInit(): void {
      this.Subscription_GetMapMainSource = this.mapHelper.mainSource$.pipe(
        filter(location => location && location.isMainSourceReady && location.isStyleReady)
      ).subscribe(location => {
        if (location && location.isMainSourceReady && location.isStyleReady) {
          if (location.loadedMapName.includes(MAP_BUILD_NAMES.GPS) || location.loadedMapName.includes(MAP_BUILD_NAMES.Unilever))
            this.layerCatalogService.isMapLayersButtonDisabled = false;
        }
    });
    }
  
    ngOnDestroy(): void {
      if (this.Subscription_GetMapMainSource)
        this.Subscription_GetMapMainSource.unsubscribe();
    }
  
  

    onClickListaCapas() {
      this.layerCatalogService.isExternalLayersVisible = false;
      this.layerCatalogService.isInternalLayersVisible = false;
      this.layerCatalogService.isGeneralManagementVisible = false;
      this.layerCatalogService.isMapLayersVisible = !this.layerCatalogService.isMapLayersVisible;
    }
  
    //se acciona al presionar el switch de una capa, capaActivada es el evento seleciconado
  
    onToggleLayerTraffic() {
      this.panelMapLayerService.onToggleLayerTraffic();
    }

  
    ClosePanel() {
      this.layerCatalogService.isMapLayersVisible = false;
    }

}
